import { courseSchema, type Course } from '@rcs/data-schema';
import { SAMPLE_COURSES } from '../sample-course';

/** 仮のコース（保存データの形式）の ID。 */
const SAMPLE_COURSE_ID = '00000000-0000-4000-8000-000000000001';

/** {@link createSampleCourse} のオプション。 */
export interface SampleCourseOptions {
  /** コースの ID（既定：仮のコースの固定 ID） */
  readonly id?: string | undefined;
  /** コースの名前（既定：「サンプル（名前）」） */
  readonly name?: string | undefined;
  /** 作成・更新日時（ISO 8601） */
  readonly now?: string | undefined;
}

/**
 * 仮のコース（`SAMPLE_COURSES` の名前）から、保存データの形式のコースを作る。
 * 制御点の ID は `c1`, `c2`, … とする。新しいコースの雛形にも使う。
 */
export function createSampleCourse(name: string, options: SampleCourseOptions = {}): Course {
  const sample = SAMPLE_COURSES[name] ?? SAMPLE_COURSES.default;
  if (!sample) throw new Error('仮のコースがありません');
  const now = options.now ?? '2026-10-11T00:00:00.000Z';
  return courseSchema.parse({
    id: options.id ?? SAMPLE_COURSE_ID,
    name: options.name ?? `サンプル（${name}）`,
    closed: sample.course.closed,
    controlPoints: sample.course.points.map((position, index) => {
      const segment = sample.segments?.[index];
      return {
        id: `c${String(index + 1)}`,
        position,
        bank: sample.course.banks?.[index] ?? 0,
        segment: segment?.type ?? 'normal',
        ...(segment?.params === undefined ? {} : { segmentParams: segment.params }),
      };
    }),
    createdAt: now,
    updatedAt: now,
  });
}
